import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { EditorConfigContext } from '../../contexts/EditorConfigContext';
import useSummaryCommand from './useSummaryCommand';
import { useContext } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { RTEToolbarLoadingButton } from '../../components/StyledTextToolbarButton';
import UITextToolbarIcon from 'rich-text-lib/components/editor/UITextToolbarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InsertGeneratedAISummary() {
  const editorConfig = useContext(EditorConfigContext);
  const summaryConfig = editorConfig.AI_SUMMARY;
  const globalSettingEnabled = summaryConfig ? summaryConfig.globalSettingEnabled : false;
  const settingsUrl = `${getFullUrl('app')}/settings/${PortalIdParser.get()}/ai-assistants`;
  const {
    isLoading: isGeneratingSummary,
    generateSummary
  } = useSummaryCommand();
  return /*#__PURE__*/_jsx(UITooltip, {
    title: globalSettingEnabled ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.insertSummary"
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: 'hubspot-prosemirror.tooltips.customerAnalysisSettingOff_jsx',
      elements: {
        Link: UILink
      },
      options: {
        href: settingsUrl,
        external: true
      }
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarLoadingButton, {
      use: "primary-white",
      size: "extra-small",
      loading: isGeneratingSummary,
      onClick: generateSummary,
      disabled: !globalSettingEnabled,
      children: /*#__PURE__*/_jsx(UITextToolbarIcon, {
        name: "bulb",
        disabled: !globalSettingEnabled
      })
    })
  });
}